// Load Helpers FIRST - needed by other components (mergeDeep, etc.)
import './components/Helpers';
import './index';
// Use generated FontAwesome subset instead of full all.min bundle
import './fa-icons.generated';
// Use generated FontAwesome SCSS subset instead of full CSS bundle
import '../css/fa-icons.generated.scss';
import './components/Naja';
import './components/LiveFormValidation';
import {LiveForm, Nette} from 'live-form-validation';
import './components/toastr';

// Webpack HMR
if (module.hot) {
	module.hot.accept();
}

Nette.initOnLoad();
window.Nette = Nette;
window.LiveForm = LiveForm;
